import React, { useEffect, useState } from "react";
import AlternativeProductSuggestions from "./AlternativeProductSuggestions";
import { InternalNotesData, OutletItemWarehouse } from "./InternalNotesResult";
import ItemNotes from "./ItemNotes";
import ProcurementContacts from "./ProcurementContacts";
import ProductData from "./ProductData";
import InternalNotesStockCount from "./InternalNotesStockCount";
import VendorNotes from "./VendorNotes";
import InternalNotesVendorAlert from "./InternalNotesVendorAlert";
import InternalNotesKitStockCounts from "./InternalNotesKitStockCounts";
import InternalNotesContentUseOnly from "./InternalNotesContentUseOnly";
interface Props {
  internalNotesData: InternalNotesData;
  itemNumber: string;
  outletItemNumber: string;
}
const InternalNotesBody = ({
  internalNotesData,
  itemNumber,
  outletItemNumber
}: Props) => {
  const {
    actualWeight,
    alternativeProducts,
    categoryPageLink,
    countryOfManufacture,
    feedIdentifier,
    groupingFlag,
    isExternal,
    kitComponentStocks,
    notes,
    procurementContacts,
    stockData,
    vendorAlert,
    contentUseOnlyData,
    outletWarehouseNumbers
  } = internalNotesData;
  const [outletWarehouseNumber, setOutletWarehouseNumber] = useState(0);
  const [isOutletItem, setIsOutletItem] = useState(false);
  const hasKitStocks = kitComponentStocks?.length > 0;
  const kitStockType =
  // eslint-disable-next-line no-nested-ternary
  kitComponentStocks?.length > 0 ? kitComponentStocks.findIndex(k => k.stockType === "PA") >= 0 ? "PA" : "OD" : "";
  useEffect(() => {
    const getOutletWarehouseNumber = () => {
      const outletWarehouse = outletWarehouseNumbers?.find((item: OutletItemWarehouse) => outletItemNumber.includes(item.outletProductNumber.toString()));
      if (outletWarehouse) {
        return outletWarehouse.warehouseNumber;
      }
      return null;
    };
    const warehouseNumber = getOutletWarehouseNumber();
    if (warehouseNumber) {
      setIsOutletItem(true);
      setOutletWarehouseNumber(warehouseNumber);
    }
  }, [outletItemNumber, outletWarehouseNumbers]);
  return <div className="wi-content" data-sentry-component="InternalNotesBody" data-sentry-source-file="InternalNotesBody.tsx">
      {vendorAlert && <InternalNotesVendorAlert vendorAlerts={vendorAlert} />}
      {feedIdentifier?.length > 0 && <p data-testid="feedIdentifier">{`Feed Identifier: ${feedIdentifier}`}</p>}
      {notes?.vendorNotes?.length > 0 && <VendorNotes vendorNotes={notes.vendorNotes} />}
      {notes?.itemNotes?.length > 0 && <ItemNotes itemNotes={notes.itemNotes} />}
      {isOutletItem && <p>
          <span style={{
        fontWeight: "bold"
      }}>Warehouse Location:</span>{" "}
          {outletWarehouseNumber}
        </p>}
      <InternalNotesStockCount stockData={stockData} grouping={groupingFlag} hasKitStocks={hasKitStocks} kitStockType={kitStockType} data-testid="internalNotesStockCount" data-sentry-element="InternalNotesStockCount" data-sentry-source-file="InternalNotesBody.tsx" />
      <ProductData actualWeight={actualWeight} countryOfManufacture={countryOfManufacture} isExternal={isExternal} data-sentry-element="ProductData" data-sentry-source-file="InternalNotesBody.tsx" />
      {hasKitStocks && <InternalNotesKitStockCounts kitStockData={kitComponentStocks} itemNumber={itemNumber} />}
      <AlternativeProductSuggestions alternativeProducts={alternativeProducts} categoryPageLink={categoryPageLink} data-sentry-element="AlternativeProductSuggestions" data-sentry-source-file="InternalNotesBody.tsx" />
      {procurementContacts && <ProcurementContacts procurementContactsData={procurementContacts} />}
      <InternalNotesContentUseOnly contentUseOnlyData={contentUseOnlyData} itemNumber={itemNumber} data-sentry-element="InternalNotesContentUseOnly" data-sentry-source-file="InternalNotesBody.tsx" />
    </div>;
};
export default InternalNotesBody;